import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'

const client = new ApolloClient({
  link: new HttpLink({
    uri: `${process.env.REACT_APP_LEDGER_API_HOST}/graphql`,
    fetch
  }),
  cache: new InMemoryCache()
})

export default client



// WEBPACK FOOTER //
// ./src/config/apollo/ledgerClient.js